import { render, staticRenderFns } from "./SendEgiftPanelReviewRecipients.vue?vue&type=template&id=02453b28&scoped=true"
import script from "./SendEgiftPanelReviewRecipients.vue?vue&type=script&lang=ts"
export * from "./SendEgiftPanelReviewRecipients.vue?vue&type=script&lang=ts"
import style0 from "./SendEgiftPanelReviewRecipients.vue?vue&type=style&index=0&id=02453b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02453b28",
  null
  
)

export default component.exports